import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aesthetic-individuality-report',
  templateUrl: './aesthetic-individuality-report.component.html',
  styleUrls: ['./aesthetic-individuality-report.component.scss']
})
export class AestheticIndividualityReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
